export default "/images/aedc941760b6751a5bcccf9895475c2f.avif";